import { FONT_FAMILY } from 'shared/components/Text/Text';
import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
* {
    box-sizing: border-box;
    font-family: ${FONT_FAMILY};
}


html,
body {
    margin: 0;
    padding: 0;
    font-family: Avenir;
    
    ::-webkit-scrollbar-track {
        background: transparent; 
        box-shadow: white;
      }

    // Modal transition sliding in from the right
    .info-drawer__overlay {
        opacity: 0;
        transition: opacity 300ms ease-in-out;
    }

    .info-drawer__overlay.ReactModal__Overlay--after-open {
        opacity: 1;
    }

    .info-drawer__overlay.ReactModal__Overlay--before-close {
        opacity: 0;
    }
    

    .info-drawer__content {        
        bottom: 0;
        top: auto;
        right: auto;
        left: 0;
        transform: translateY(100%);
        transition: transform 300ms ease-in-out;
        
        @media screen and (min-width: 640px) {
            right: 0;
            transform: translateX(100%);
        }
    }

    .info-drawer__content.ReactModal__Content--after-open {
        transform: translateY(0);

        @media screen and (min-width: 640px) {
            transform:  translateX(0);
        }
    }

    .info-drawer__content.ReactModal__Content--before-close {
        transform: translateY(100%);

        @media screen and (min-width: 640px) {
            transform:  translateX(100%);
        }
    }
}

a {
    text-decoration: none;
}

`;

export default GlobalStyles;
